// Filter bit array action types
export const ACTIVATE_BITS = 'ACTIVATE_BITS'

export const TOGGLE_BITS = 'TOGGLE_BITS'


// Item set action types
export const SET_ADDED_ITEM = 'SET_ADDED_ITEM'

export const SET_CHECKED_ITEM = 'SET_CHECKED_ITEM'


// Results action types
export const UPDATE_RESULTS = 'UPDATE_RESULTS'
